// extracted by mini-css-extract-plugin
export default {"spin":"NewCreateConversations_spin__RDihT"};